interface TagProps {
  label: string
  onClick?: (e: any) => void
  className?: string
}
export const CustomTag: React.FC<TagProps> = ({label, onClick, className = ''}) => {
  return (
    <div
      onClick={onClick}
      className={`
       inline-flex cursor-default items-center justify-center px-4 py-1 rounded-full leading-none font-semibold whitespace-nowrap ${className}`}
    >
      {label}
    </div>
  )
}
